import { Box, Flex, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { useState } from "react";
import matches from "../matches.json";

export default function MatchFixtures() {
  const [selectedMatch, setSelectedMatch] = useState(matches[0] || {});

  // Handler to update the selected match
  const handleMatchClick = (match) => {
    setSelectedMatch(match);
  };

  return (
    <div
      style={{
        backgroundImage: `url('/img/HeroMensHockeyAsiaCup2025Rajgir/watermark-logo.png')`,
        backgroundColor:"#fdf6",
        backgroundSize: "contain", // Or 'cover' depending on the behavior you want
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div style={{ marginTop: "20px" }}>
        <h3>पुरुष एशिया हॉकी कप 2025</h3>
        <h5 style={{ color: "#FF3E5D", marginTop: "8px" }}>
          29 अगस्त, 2025 - 7 सितम्बर, 2025
        </h5>
        <h5 style={{ marginTop: "8px" }}>राजगीर, बिहार</h5>
      </div>

      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        p={8}
        w="100%"
        maxW="1200px"
        mx="auto"
        gap={16}
      >
        {/* Upcoming Matches Section */}
        <Box flex="1">
          <Text
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="bold"
            style={{ color: "#421B16" }}
          >
            आयोजित मैच
          </Text>
          <Text color="gray.500" mt={2}>
            आगामी प्रतियोगिताओं और खिलाड़ियों से संबंधित सभी कार्यक्रमों,
            समाचारों और जानकारियों के लिए एक पूर्ण अनुसूची प्राप्त करें।
          </Text>
          <VStack spacing={6} mt={8} maxH="300px" overflowY="scroll">
            {matches.map((match) => (
              <HStack
                key={match.id}
                w="100%"
                justify="space-between"
                cursor="pointer"
                onClick={() => handleMatchClick(match)} // Click handler to update the left side
                _hover={{ bg: "gray.100" }}
                p={4}
                borderRadius="md"
              >
                <VStack>
                  <Text fontSize="5xl" fontWeight="bold" color="green.400">
                    {match.date.split(" ")[0]}
                  </Text>
                  <Text fontSize="md" color="gray.500">
                    {match.date.split(" ")[1]}
                  </Text>
                </VStack>
                <Box flex="1" ml={4}>
                  <Text fontWeight="bold">{match.tournament}</Text>
                  <Text color="gray.500">
                    {match.time}, {match.player1} - {match.player2}
                  </Text>
                </Box>
              </HStack>
            ))}
          </VStack>
        </Box>
        {/* Match Details Section */}
        <Box flex="1" mr={{ base: 0, md: 8 }} mb={{ base: 8, md: 0 }}>
          <Text
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="bold"
            style={{ color: "#2C4089" }}
          >
            मैच विवरण
          </Text>
          <Text color="blue.500" mt={2}>
            इस सत्र के लिए प्रमुख टूर्नामेंट के परिणामों, स्कोर, आँकड़े और स्टैंडिंग के बारे में अपडेट प्राप्त करें।
          </Text>
          <Flex
            direction={{ base: "column", md: "row" }} // Column layout for small screens, row for larger
            align={{ base: "center", md: "center" }}
            mt={8}
            style={{ marginTop: "50px" }}
          >
            <VStack spacing={4}>
              <Image
                boxSize={{ base: "100px", md: "150px" }} // Adjust image size based on screen size
                objectFit="cover"
                src={selectedMatch.player1Img}
                alt={selectedMatch.player1}
              />
              <Text
                fontWeight="bold"
                fontSize={{ base: "3xl", md: "5xl" }}
                style={{ marginTop: "30px" }}
              >
                {selectedMatch.player1}
              </Text>
            </VStack>

            <VStack mx={{ base: 0, md: 6 }} my={{ base: 6, md: 0 }}>
              <Text fontSize={{ base: "sm", md: "md" }} color="gray.500">
                {selectedMatch.date} {selectedMatch.time}
              </Text>
              <Text fontSize={{ base: "3xl", md: "4xl" }} fontWeight="bold">
                {selectedMatch.score ? selectedMatch.score : "TBD"}
              </Text>
              <Text color="gray.500" textAlign="center">
                {selectedMatch.tournament} <br />
                {selectedMatch.venue}
              </Text>
            </VStack>

            <VStack spacing={4}>
              <Image
                boxSize={{ base: "100px", md: "150px" }} // Adjust image size based on screen size
                objectFit="cover"
                src={selectedMatch.player2Img}
                alt={selectedMatch.player2}
              />
              <Text
                fontWeight="bold"
                fontSize={{ base: "3xl", md: "5xl" }}
                style={{ marginTop: "30px" }}
              >
                {selectedMatch.player2}
              </Text>
            </VStack>
          </Flex>
        </Box>
      </Flex>
    </div>
  );
}
